/*
  Printable gift card.
  Loads the title and image of the product given in the ?product= url parameter and prints the page on request.
  With ?variant=ID the image of that variant (for example the ordered color) is used instead of the product image.

  HTML Usage:
  <gift-card-print>
    <img data-gift-card-image>
    <p data-gift-card-title></p>
    <button data-gift-card-print>Print</button>
  </gift-card-print>
*/

if (!customElements.get('gift-card-print')) {
  class GiftCardPrint extends HTMLElement {
    constructor() {
      super();

      this.image = this.querySelector('[data-gift-card-image]');
      this.titleElement = this.querySelector('[data-gift-card-title]');
      this.printButton = this.querySelector('[data-gift-card-print]');

      this.printButton?.addEventListener('click', () => window.print());

      const params = new URLSearchParams(window.location.search);
      const handle = params.get('product');
      if (handle) this.loadProduct(handle, params.get('variant'));
    }

    /*
      Show an image at 800px wide
      @param src {string}: image url from the product json
      @param alt {string}: alt text
    */
    setImage(src, alt) {
      const imageUrl = new URL(src, window.location.origin);
      imageUrl.searchParams.set('width', '800');

      this.image.src = imageUrl.href;
      this.image.alt = alt;
      this.image.classList.remove('hidden');
    }

    /*
      Load the product from the .js endpoint and fill the title and image
      @param handle {string}: product handle
      @param variantId {string|null}: variant id, to show the image of that variant
    */
    async loadProduct(handle, variantId) {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) return;

        const product = await response.json();

        if (this.titleElement && product.title) {
          this.titleElement.textContent = product.title;
          this.titleElement.classList.remove('hidden');
        }

        const variant = variantId ? product.variants.find(item => String(item.id) === variantId) : null;
        const imageSrc = variant?.featured_image?.src || product.featured_image;

        if (this.image && imageSrc) {
          if (variant?.featured_image?.src && product.featured_image) {
            this.image.addEventListener('error', () => this.setImage(product.featured_image, product.title), { once: true });
          }
          this.setImage(imageSrc, product.title);
        }
      }
      catch (error) {
        debug() && console.error(error);
      }
    }
  }

  window.GiftCardPrint = GiftCardPrint;
  customElements.define('gift-card-print', GiftCardPrint);
}
